"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralSuffix = exports.ordinalNumber = exports.stubbify = void 0;
function stubbify(id) {
    if (id) {
        return '${' + id + '}';
    }
    else {
        return '';
    }
}
exports.stubbify = stubbify;
function ordinalNumber(input) {
    var exceptions = { 1: 'st', 2: 'nd', 3: 'rd' };
    var suffix = 'th';
    if (input < 4 || input > 20) {
        suffix = exceptions[input % 10] || 'th';
    }
    return "".concat(input).concat(suffix);
}
exports.ordinalNumber = ordinalNumber;
function pluralSuffix(value, suffix) {
    if (value <= 0) {
        return "no ".concat(suffix, "s");
    }
    else if (value === 1) {
        return "1 ".concat(suffix);
    }
    else {
        return "".concat(value, " ").concat(suffix, "s");
    }
}
exports.pluralSuffix = pluralSuffix;
//# sourceMappingURL=template_helpers.js.map